import {Injectable, inject} from '@angular/core';
import {NogaIndustriesService} from '../../services/domain/reference-data/noga-industries/noga-industries.service';

@Injectable({
  providedIn: 'root',
})
export class NogaIndustriesResolver {

  private nogaIndustriesService = inject(NogaIndustriesService);

  resolve(): Promise<void> {
    return this.nogaIndustriesService.getNogaIndustries();
  }

}
